<template>
  <div class="flex-1 overflow-auto p-4">
    <woot-button
      color-scheme="success"
      class-names="button--fixed-top"
      icon="arrow-download"
      @click="downloadReport"
    >
      {{ $t('WORK_ORDER_REPORTS.DOWNLOAD_WORK_ORDER_REPORTS') }}
    </woot-button>
    <work-order-report-filter
      :period="selectedPeriod"
      @update-period="updatePeriod"
    />
    <work-order-report-container
      :report="report"
      :uiFlags="uiFlags.isFetchingWorkOrderSummary"
    />
    <work-order-task-report
      :tableData="tableData"
      :uiFlags="uiFlags.isFetchingWorkOrderSummary"
    />
  </div>
</template>

<script>
import {
  downloadCsvFile,
  generateFileName,
} from '../../../../helper/downloadHelper';
import { mapGetters } from 'vuex';
import WorkOrderReportFilter from './components/WorkOrderReportFilter.vue';
import WorkOrderReportContainer from './WorkOrderReportContainer.vue';
import WorkOrderTaskReport from './WorkOrderTaskReport.vue';

export default {
  components: {
    WorkOrderReportFilter,
    WorkOrderReportContainer,
    WorkOrderTaskReport,
  },

  data() {
    return {
      selectedPeriod: this.getThisMonth(),
    };
  },

  computed: {
    ...mapGetters({
      report: 'complaints/getWorkOrderSummary',
      tableData: 'complaints/getWorkOrderGlobal',
      uiFlags: 'complaints/getUiFlags',
    }),
  },
  methods: {
    async fetchWorkOrderTaskSummary(period = null) {
      const selectedPeriod = period || this.getThisMonth();
      this.$store.dispatch('complaints/setWorkOrderGlobal', {
        period: selectedPeriod,
      });
    },

    getThisMonth() {
      const today = new Date();
      return new Date(today.getFullYear(), today.getMonth(), 1);
    },

    async fetchReport(period = null) {
      const selectedPeriod = period || this.getThisMonth();

      await this.$store.dispatch('complaints/setWorkOrderSummary', {
        period: selectedPeriod,
      });
    },

    async downloadReport() {
      try {
        const period = this.selectedPeriod;
        const reportData = await this.$store.dispatch(
          'complaints/setWorkOrderReport',
          {
            period,
          }
        );

        const fileName = generateFileName({
          type: 'work_order_report',
          to: Math.floor(new Date(period).getTime() / 1000),
        });

        downloadCsvFile(fileName, reportData);
      } catch (error) {
        console.error('Error downloading report:', error);
      }
    },

    updatePeriod(value) {
      if (!value) return;
      this.selectedPeriod = value;
      this.fetchReport(value);
      this.fetchWorkOrderTaskSummary(value);
    },
  },

  mounted() {
    this.fetchReport();
    this.fetchWorkOrderTaskSummary();
  },
};
</script>

<style scoped>
.filter-container {
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
}
</style>
